<div
  class="card border border-success pointer h-100"
  [routerLink]="['/organization', organization.id, 'activities', activity.id]">
  <div *ngIf="!activity.imageUrl" class="d-flex align-items-center justify-content-center" style="height: 70px">
    <small class="text-muted fst-italic text-smaller text-center"> Bild saknas </small>
  </div>

  <img [src]="activity.imageUrl" *ngIf="activity.imageUrl" class="card-img-top" alt="Aktivitetsbild för {{ activity.name }}" />
  <div class="card-body d-flex flex-column">
    <h5 class="card-title">{{ activity.name }}</h5>
    <p class="card-text text-smaller text-muted">
      <small class="text-uppercase fw-bold"
        ><span *ngIf="activity.type !== 'template'">{{ activity.participantCount }} deltagare, </span>{{ activity.productCount }}
        {{ activity.productCount === 1 ? 'Produkt' : 'Produkter' }}</small
      >
      <small class="d-block text-uppercase">Ansvarig: {{ activity.responsible }}</small>
    </p>
    <div class="d-flex mt-auto" *ngIf="activity.type !== 'template'">
      <a
        href="#"
        class="btn btn-outline-primary d-block flex-fill"
        [routerLink]="['/organization', organization.id, 'activities', activity.id]"
        >Översikt</a
      >
      <a
        href="#"
        class="ms-2 btn btn-outline-dark d-inline d-sm-none"
        [routerLink]="['/organization', organization.id, 'activities', activity.id, 'participants']"
        fragment="p"
        ><span class="material-icons">groups</span></a
      >
      <a
        href="#"
        class="ms-2 btn btn-outline-dark d-none d-sm-inline"
        [routerLink]="['/organization', organization.id, 'activities', activity.id, 'participants']"
        ><span class="material-icons">groups</span></a
      >
    </div>
  </div>
  <div
    class="card-footer py-1 d-flex"
    [ngClass]="{
      'justify-content-between': activity.type !== 'template',
      'justify-content-center': activity.type === 'template',
    }">
    <ng-container *ngIf="activity.type === 'template'">
      <small class="text-success fw-bold text-uppercase text-smaller" *ngIf="activity.publishedAsTemplate"
        ><span class="material-icons me-1 align-middle">visibility</span>Synlig för underorganisationer</small
      >
      <small class="text-center text-muted fw-bold text-uppercase text-smaller" *ngIf="!activity.publishedAsTemplate"
        ><span class="material-icons me-1 align-middle">visibility_off</span>Ej synlig</small
      >
    </ng-container>
    <ng-container *ngIf="activity.type !== 'template'">
      <small *ngIf="!activity.productSelectionDeadline && !activity.paymentDeadline"> &nbsp; </small>
      <small title="Avgiftsval">
        <ng-container *ngIf="activity.productSelectionDeadline">
          <span class="material-icons align-middle me-1">rule</span>
          <small
            class="text-smallest align-middle"
            [ngClass]="{
              'text-info': activity.productSelectionDeadline > now,
              'text-danger': activity.productSelectionDeadline < now,
            }">
            <ng-container *ngIf="activity.productSelectionDeadline < now"
              >Avslutades {{ activity.productSelectionDeadline | date: friendlyDateTimeShort }}</ng-container
            >
            <ng-container *ngIf="activity.productSelectionDeadline > now">
              Tillgänglig till
              {{ activity.productSelectionDeadline | date: friendlyDateTimeWithDayShort }}</ng-container
            >
          </small>
        </ng-container>
      </small>
      <small class="text-end" title="Betalning">
        <ng-container *ngIf="activity.paymentDeadline">
          <span class="material-icons align-middle me-1">payments</span>
          <small
            class="text-smallest align-middle"
            [ngClass]="{
              'text-info': activity.paymentDeadline > now,
              'text-danger': activity.paymentDeadline < now,
            }">
            <ng-container *ngIf="activity.paymentDeadline < now"
              >Avslutades {{ activity.paymentDeadline | date: friendlyDateTimeShort }}</ng-container
            >
            <ng-container *ngIf="activity.paymentDeadline > now">
              Tillgänglig till
              {{ activity.paymentDeadline | date: friendlyDateTimeWithDayShort }}</ng-container
            >
          </small>
        </ng-container>
      </small>
    </ng-container>
  </div>
</div>
